exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".footer {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: 5px;\n  background-color: #eee;\n  text-align: center;\n}\n\na {\n  padding: 10px;\n  font-weight: 500;\n  font-size: 12px;\n  text-transform: uppercase;\n  border-radius: 3px;\n  text-decoration: none;\n  position: relative;\n  display: block;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/mowebdevice/Desktop/Web Project/angular-scrubup/src/app/footer/footer.component.scss
// module id = ../../../../../src/app/footer/footer.component.scss
// module chunks = main